import { useState, useMemo } from "react";
import useSupabaseData from "../hooks/useSupabaseData";
import { processHistoricalData } from "../scripts/historical-script";

const LoadHistoricalData = () => {
  const { loadData } = useSupabaseData();
  const [supabaseData, setSupabaseData] = useState(null);

  const loadInitialData = async () => {
    try {
      const data = await loadData();
      if (data && data.length > 0) {
        setSupabaseData(data);
      }
    } catch (err) {
      console.log(
        "No existing data in Supabase or error loading:",
        err.message
      );
    }
  };

  const loadDataFromNewTable = async () => {
    try {
      // const data = await pullDataFromSupabaseNewTable();
      // console.log("data", data);
      // console.log(calculateSummaryStats(data.affiliates));
    } catch (err) {
      console.log("Error loading data from new table:", err.message);
    }
  };

  const csvDataFromSupabase = useMemo(() => {
    if (!supabaseData) return null;

    return supabaseData.map((row) => ({
      Date: row.date || "",
      "Ad Name": row.ad_name || "",
      "Campaign Name": row.campaign_name || "",
      "Adset Name": row.adset_name || "",
      "Ad Spend": row.spend || 0,
      "Pixel CV": row.revenue || 0,
      ROAS: row.spend > 0 ? row.revenue / row.spend : 0, // Calculate ROAS
      "Pixel ROAS": row.spend > 0 ? row.revenue / row.spend : 0, // Same as ROAS
      "Pixel Purchases": row.purchases || 0,
      "Pixel CPA": row.cpa || "",
      "Pixel AOV": row.aov || "",
      Profit: row.profit || 0,
      Commission: row.commission || 0,
      Clicks: row.clicks || 0,
      Impressions: row.impressions || 0,
      // Add affiliate extraction logic
      affiliate: row.affiliate_name || "",
    }));
  }, [supabaseData]);

  const processedData = useMemo(async () => {
    if (!csvDataFromSupabase) return null;

    console.log("csvDataFromSupabase", csvDataFromSupabase);

    await processHistoricalData(csvDataFromSupabase);
    return csvDataFromSupabase;
  }, [csvDataFromSupabase]);

  return (
    <div className="flex flex-col items-center justify-center h-screen gap-8">
      <button
        className="bg-blue-500 text-white p-2 rounded-md"
        onClick={() => {
          loadInitialData();
        }}
      >
        Click Me for historical data
      </button>

      <button
        className="bg-blue-500 text-white p-2 rounded-md"
        onClick={() => {
          loadDataFromNewTable();
        }}
      >
        Print out the exiting data
      </button>
    </div>
  );
};

export default LoadHistoricalData;
